<div class="contract-details-page">
  <section class="contract-card" aria-live="polite">
    <div class="card-icon">
      <span class="loader"></span>
    </div>

    <h1>Redirecting to contract details...</h1>
    <p class="card-copy">
      Please wait while we open your contract.
    </p>
  </section>
</div>
